export const faqs = [
  {
    q: "哪些电影或电视剧里的潘金莲最值得一看？",
    a: "如果偏好作者电影，可以从1982年李翰祥的《武松》与1989年罗卓瑶的《潘金莲之前世今生》入手；如果想看大众熟悉度最高的版本，央视1998年《水浒传》和2011年新版《水浒传》更具代表性。不同版本的价值在于呈现了同一角色的不同侧面。",
  },
  {
    q: "潘金莲在历史上真的有原型吗？",
    a: "目前学界普遍把潘金莲视为《水浒传》《金瓶梅》中的文学人物。民间流传着一些关于其原型的说法（如清河一地的传说），但这些多属野史与地方讲述，尚缺乏确凿史料可以证实，宜作为传说看待。",
  },
  {
    q: "影视改编和原著差别大吗？",
    a: "差别通常不小。原著更侧重情节推进与道德评判，而影视作品受篇幅、时代与类型影响，往往会补充人物心理、调整结局或改变基调。这也是为什么同一个潘金莲，在不同作品里会给人完全不同的印象。",
  },
  {
    q: "为什么不同版本里的潘金莲反差这么大？",
    a: "因为改编者面对的是不同的观众和不同的年代。有的是商业类型片，需要浓烈的戏剧性；有的是长篇电视剧，需要更完整的人物弧线；还有的带有明显的当代性别视角。创作目的不同，人物形象自然不同。",
  },
  {
    q: "阅读原著前需要先看电影吗？",
    a: "不需要，顺序可以按兴趣来。先看影视作品有助于快速进入故事，再读原著则能感受到文本原本的道德结构与叙事节奏；反过来先读原著，再看改编也能更清楚地看到“改了什么”。两种顺序各有收获。",
  },
  {
    q: "本站的内容是影评还是资料整理？",
    a: "本站更偏向资料整理与背景介绍，帮助你快速了解潘金莲题材影视作品的故事原型、历史形象讨论、角色分析与改编差异，方便你决定从哪一部、哪一个角度开始看起。",
  },
];